var map = {
	"./": 812,
	"./App": 111,
	"./App.css": 50,
	"./App.js": 111,
	"./assets/Traffix Logo - Transparent colored.png": 544,
	"./assets/TraffixLogo.png": 803,
	"./assets/backg.jpg": 446,
	"./assets/background.jpg": 732,
	"./assets/betwin.png": 905,
	"./assets/exis.svg": 633,
	"./assets/logo-societa.png": 480,
	"./assets/logo-societa1.png": 299,
	"./assets/logo-societa2.png": 440,
	"./assets/logo-societa3.png": 657,
	"./assets/logo-societa4.png": 566,
	"./assets/logo-societa5.png": 55,
	"./assets/logo-traffix.png": 926,
	"./assets/logo-traffix1.png": 893,
	"./assets/mysteryx.png": 889,
	"./assets/semafix.png": 53,
	"./assets/signalfix.png": 571,
	"./assets/simfix.png": 834,
	"./assets/syncfix2.png": 928,
	"./components/Chatbot": 650,
	"./components/Chatbot.css": 963,
	"./components/Chatbot.jsx": 650,
	"./components/DemoForm": 18,
	"./components/DemoForm.jsx": 18,
	"./components/ServiceCard": 820,
	"./components/ServiceCard.jsx": 820,
	"./index": 812,
	"./index.js": 812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 538;